import { create } from "zustand";

const useVersionStore = create((set) => ({
  mobileVersion: "snapshot-master-4.7.0-2-g3087f23" || "dev",
  setMobileVersion: (mobileVersion) => set({ mobileVersion }),

  serverVersion: "",
  setServerVersion: (serverVersion) => set({ serverVersion, serverVersionFetchFailed: false }),

  // Tracks whether the last attempt to fetch the server version failed
  // (network error, timeout, or an unusable response), as distinct from
  // a successful fetch that simply differs from mobileVersion.
  serverVersionFetchFailed: false,
  setServerVersionFetchFailed: (serverVersionFetchFailed) => set({ serverVersionFetchFailed }),
}));

export default useVersionStore;
